import React, { useEffect, useState } from 'react';
import { useStyles } from './style';
import clsx from 'clsx';

const PaginationComponenets = ({
  pageCount,
  itemsPerPage,
  currentPage,
  onChange,
  removePrePage,
  localCall = false,
}) => {
  const [countPage, setCountPage] = useState(0); // استیت مربوط به تعداد صفحه
  const [countPrePage, setCountPrePage] = useState(10); //استیت مربوط به صفحه بندی ردیف ها
  const [changeData, setChangeData] = useState(false); //با این فلگ از چندین بار درخواست کال شدن جلوگیری میکند
  const [pageNumbers, setPageNumber] = useState([1]); //با این فلگ از چندین بار درخواست کال شدن جلوگیری میکند
  let totalItems = Math.ceil(pageCount / itemsPerPage); // تعداد کل ردیف های جدول
  const classes = useStyles();
  let firstItem = (pageCount < 10 ? pageCount : currentPage * countPrePage) - countPrePage + 1;
  let lastItem = pageCount < 10 ? pageCount : currentPage * countPrePage;
  useEffect(() => {
    // تابع مربوط به ایجاد آبجکت صفحه بندی همراه با چند نقطه
    generatePageNumber();
    onChange({
      page: Number(countPage),
      pageSize: Number(countPrePage),
      pageNumber: countPage === 0 ? 0 : countPage - 1,
      changeData: changeData,
    });

    // در این onchange پارامتر ها و فلگر مربوط به تعداد صفحات و ایتم ها رو برای پرنت میفرستد.
  }, [countPrePage, countPage]);

  const generatePageNumber = () => {
    setCountPrePage(itemsPerPage);
    let data = [];
    for (let i = 1; i <= totalItems; i++) {
      // در این حلقه مورد مربوط به خلاصه سازی تعداد صفحات و با 3 نقطه پیاده میکن و در نهایت یک آبجکت ایجاد میکند از اعداد و تعداد صفحه
      if (
        i === 1 ||
        i === totalItems ||
        i === currentPage ||
        i === currentPage - 1 ||
        i === currentPage + 1
      ) {
        data.push(i);
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        data.push('...');
      }
    }

    if (data?.length == 0) data.push(1);
    setPageNumber(data);
  };

  const nextPage = (ischange) => {
    // تابع مربوط به کلید صفحه بعدی
    onChange({
      page: currentPage + 1,
      pageSize: Number(countPrePage),
      pageNumber: currentPage < 0 ? 0 : currentPage,
      changeData: ischange,
    });
  };

  const prevPage = (ischange) => {
    // تابع مربوط به دکمه صفحه قبلی
    onChange({
      page: currentPage - 1,
      pageSize: Number(countPrePage),
      pageNumber: currentPage < 0 ? 0 : currentPage - 2,
      changeData: ischange,
    });
  };

  return (
    <div className={classes.paginationBlock}>
      <div className={classes.pagination}>
        <button
          className={clsx(classes.pageItem)}
          type="button"
          onClick={() => {
            prevPage(true);
          }}
          disabled={currentPage === 1}
        >
          قبلی
        </button>
        {pageNumbers &&
          pageNumbers.map((number, index) =>
            number === '...' ? (
              <div className={classes.dotts}>{number}</div>
            ) : (
              <button
                type="button"
                disabled={currentPage == number}
                key={number}
                className={clsx(classes.pageItem, {
                  active: currentPage == number,
                })}
                onClick={() => {
                  setChangeData(true), setCountPage(Number(number));
                  if (localCall) {
                    onChange({
                      page: Number(number),
                      pageSize: Number(number),
                      pageNumber: number === 0 ? 0 : number - 1,
                      changeData: changeData,
                    });
                  }
                }}
              >
                {number}
              </button>
            ),
          )}
        <button
          type="button"
          className={clsx(classes.pageItem)}
          onClick={() => {
            nextPage(true);
          }}
          disabled={currentPage === totalItems || pageNumbers?.length === 1}
        >
          بعدی
        </button>
      </div>
      <div className={classes.footerCount}>
        {!removePrePage && (
          <>
            <div className={classes.pageCount}>
              <select
                className={classes.itemsPerPage}
                value={itemsPerPage}
                disabled={pageCount <= 10 ? true : false}
                onChange={(e) => {
                  setChangeData(true), setCountPrePage(Number(e.target.value));
                }}
              >
                {[10, 20, 30].map((number) => (
                  <option key={number} value={number}>
                    {number}
                  </option>
                ))}
              </select>
              <span> نمایش در هر صفحه </span>
            </div>
            <span className={classes.pageCountAmount}>
              {' '}
              ({firstItem > 1 ? firstItem : 1} - {lastItem < pageCount ? lastItem : pageCount}) از{' '}
              {pageCount}{' '}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default PaginationComponenets;
